/** Used when `VITE_USE_MOCK_API=true` — skips login and seeds org for `getActiveOrgId()`. */
export const MOCK_ORG_ID = '0881bd35-fd34-493f-9090-702f95c1d23f'

export const MOCK_AUTH = {
  token: 'mock-local-dev-token',
  user: {
    id: 'mock-user-01727c9a-2de7-4f52-a9ff-868dfaf3f0d4',
    username: 'mock',
    email: 'mock@localhost',
    role: 'admin',
    permissions: ['*'] as string[],
    organizationIds: [MOCK_ORG_ID],
    organizations: [MOCK_ORG_ID],
    organizationsDetailed: [{ id: MOCK_ORG_ID, name: 'Mock Organization' }],
  },
} as const
